import SvgClose from "@Components/CustomIcon/SvgClose"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import React, { useState } from "react"
import { View, TouchableOpacity } from "react-native"
import Modal from "react-native-modal"
import styles from "./styles"
import { RFValue } from "react-native-responsive-fontsize"

const CustomSimpleModal = (props) => {
    const { open, toggleModal, title, children } = props

    return (
        <Modal
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            swipeDirection={["down"]}
            animationOutTiming={10}
            //onDismiss={toggleModal}
            isVisible={open}
            onSwipeComplete={toggleModal}
            onBackButtonPress={toggleModal}
            style={styles.container}
        >
            <View style={styles.content}>
                <TouchableOpacity onPress={toggleModal} style={styles.closeIcon}>
                    <SvgClose />
                </TouchableOpacity>
                {title && (
                    <BreeSerifText fontSize={RFValue(20)} style={styles.title}>
                        {title ?? ""}
                    </BreeSerifText>
                )}
                <View style={styles.modalContent}>{children}</View>
            </View>
        </Modal>
    )
}

export default CustomSimpleModal
